<template>
    <div class="Report__group-field-wrapper" v-if="hydrated">
        <div v-for="groupIterator in parseInt(fieldsInGroup)"
             :key="'groupField' + (groupIterator-1)"
             class="Report__field__submission Report__field__group"
        >
            <div v-for="(field, fieldIndex) in groupFields"
                 :key="fieldIndex"
                 class="Report__field__group__field__wrapper"
            >
                <div v-if="field.type === 'text'" class="Report__field__group__field" :class="{jsAddMargin:groupFields.length > 1}">
                    <v-text-field :label="getFieldName(field.name, groupIterator)"
                                  :name="'field' + fieldIndex + 'Data[]'"
                                  v-model="dataArray[fieldIndex][groupIterator-1]"
                                  dense
                                  outlined
                    ></v-text-field>

                    <CopyFieldValue :value="dataArray[fieldIndex][groupIterator-1]"/>
                </div>

                <div v-if="field.type === 'textarea'" class="Report__field__group__field" :class="{jsAddMargin:groupFields.length > 1}">
                    <v-textarea :label="getFieldName(field.name, groupIterator)"
                                :name="'field' + fieldIndex + 'Data[]'"
                                v-model="dataArray[fieldIndex][groupIterator-1]"
                                dense
                                outlined
                    ></v-textarea>

                    <CopyFieldValue :value="dataArray[fieldIndex][groupIterator-1]"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ReportFieldBoilerplate from '@/reports/Fields/Common/ReportFieldBoilerplate';
import axios from 'axios';
import CopyFieldValue from '@/reports/Fields/Common/CopyFieldValue';

export default {
    components: { CopyFieldValue },
    mixins: [
        ReportFieldBoilerplate,
    ],

    data() {
        return {
            fieldsInGroup: undefined,
            groupFields: undefined,
            groupNumbered: false,
            dataArray: [],
            hydrated: false,
            elementorKey: undefined,
        };
    },


    mounted() {
        this.setupGroup()
            .then(() => {
                this.loadFieldData();
            });
    },

    methods: {
        setupGroup() {
            return new Promise((resolve, reject) => {
                axios.get('/api/site/field/' + this.field.id)
                    .then((response) => {
                        const field = response.data.data.field;
                        this.fieldsInGroup = field.options.fields_in_group;
                        this.groupFields = field.options.group.fields;
                        this.groupNumbered = field.options.groupNumbered;
                        this.elementorKey = field.elementor_key;

                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
            });
        },

        loadFieldData() {
            for(let i = 0; i <= parseInt(this.fieldsInGroup); i++) {
                if (this.submission.data[i]) {
                    this.dataArray[i] = this.submission.data[i];
                }
            }

            this.hydrated = true;
        },

        setFieldKeyName(name) {
            return name.replaceAll(' ', '');
        },

        getFieldName(name, groupIterator)
        {
            let fieldName = '';
            if(name) {
                fieldName = name;
            } else {
                fieldName = this.name;
            }

            if (this.fieldsInGroup > 1 && this.groupNumbered) {
                return fieldName + ' ' + groupIterator;
            }

            return fieldName;
        }
    }
};
</script>
